import React from 'react';

export const SimpleCloseIcon: React.FC<sharedComponents.SvgIcon> = ({
  color,
  width = '10',
  height = '10',
  className,
}) => (
  <svg
    width={width}
    height={height}
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M.1.1c.2-.1.6-.1.8 0l9 9a.5.5 0 0 1-.8.8l-9-9a.5.5 0 0 1 0-.8Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.9.1c.1.2.1.6 0 .8l-9 9A.5.5 0 0 1 0 9l9-9c.2-.1.6-.1.8 0Z"
      fill={color}
    />
  </svg>
);
